import { render, staticRenderFns } from "./studentBox.vue?vue&type=template&id=52c07d80"
import script from "./studentBox.vue?vue&type=script&lang=js"
export * from "./studentBox.vue?vue&type=script&lang=js"
import style0 from "./studentBox.vue?vue&type=style&index=0&id=52c07d80&prod&lang=scss&rel=stylesheet%2Fscss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports